<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">{{ 'popins.contact.title' | translate }}</h2>
      <h3>{{ 'popins.contact.about' | translate }}</h3>
      <p>
        {{ 'popins.contact.about_text' | translate }}
        <a href="https://www.castorama.fr/relation-client/faq/" target="_blank">{{
          'popins.contact.about_link_label' | translate
        }}</a>
      </p>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <div class="inner-content">
    <div class="row">
      <div class="col-6">
        <div class="card">
          <h3>{{ 'popins.contact.phone.title' | translate }}</h3>
          <p [innerHtml]="'popins.contact.phone.text' | translate"></p>
        </div>
      </div>
      <!--<div class="col-6">
                <h3>{{ 'popins.contact.sourdine.title' | translate }}</h3>
                <p [innerHtml]="'popins.contact.sourdine.text' | translate"></p>
                <a href="https://castorama.sourdline.com/" target="_blank">{{ 'popins.contact.sourdine.cta' | translate }}</a>
            </div>-->
      <div class="col-6">
        <div class="card">
          <h3>{{ 'popins.contact.email.title' | translate }}</h3>
          <p [innerHtml]="'popins.contact.email.text' | translate"></p>
          <a href="https://www.castorama.fr/contact_us" target="_blank">{{ 'popins.contact.email.cta' | translate }}</a>
        </div>
      </div>
      <!--<div class="col-6">
                <h3>{{ 'popins.contact.stores_sav.title' | translate }}</h3>
                <p [innerHtml]="'popins.contact.stores_sav.text' | translate"></p>
                <p [innerHtml]="'popins.contact.text' | translate"></p>
                <a href="https://www.castorama.fr/find-a-store" target="_blank">{{ 'popins.contact.cta' | translate }}</a>
            </div>-->
    </div>
  </div>
</div>
